import './index.css'

import { DefaultApolloClient } from '@vue/apollo-composable'
import { createApp, provide, h } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import Ably from 'ably'
import { createAuth0 } from '@auth0/auth0-vue'
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context/index.js'
import * as Sentry from '@sentry/vue'

const ably = new Ably.Realtime({
  key: import.meta.env.VITE_ABLY_API_KEY
})

const pinia = createPinia()

const auth0 = createAuth0(
  {
    domain: import.meta.env.VITE_AUTH0_DOMAIN,
    clientId: import.meta.env.VITE_AUTH0_CLIENTID,
    authorizationParams: {
      redirect_uri: import.meta.env.VITE_AUTH0_CALLBACK_URL,
      audience: import.meta.env.VITE_AUTH0_AUDIENCE
    },
    cacheLocation: 'localstorage',
    useRefreshTokens: true,
    useRefreshTokensFallback: true
  },
  {}
)

export async function getAccessTokenSilentlyOutsideComponent(options) {
  if (!auth0.isAuthenticated.value) {
    return null
  }

  return auth0.getAccessTokenSilently(options)
}

const cache = new InMemoryCache()
const httpLink = createHttpLink({
  uri: 'https://api.linear.app/graphql'
})

const authLink = setContext((_, { headers }) => {
  const linearToken = localStorage.getItem('LINEAR_ACCESS_TOKEN')
  return {
    headers: {
      ...headers,
      authorization: `Bearer ${linearToken}`
    }
  }
})

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: cache
})

export const getAblyInstance = () => ably

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient)
  },
  render: () => h(App)
})

const feedback = Sentry.feedbackIntegration({
  autoInject: false
})

function attachFeedbackIntegration() {
  const button = document.querySelector('#report-a-bug')
  if (button) {
    feedback.attachTo('#report-a-bug')
    observer.disconnect() // Stop observing once the button is found and attached
  }
}

const observer = new MutationObserver(attachFeedbackIntegration)
observer.observe(document.body, { childList: true, subtree: true })

Sentry.init({
  app,
  dsn: 'https://23b0c26e2bdd44ed9201ffeef95d6f5f@o4505563334574080.ingest.us.sentry.io/4508672127139840',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration(), feedback]
})

app.use(router)
app.use(auth0)
app.use(pinia)

app.mount('#app')
